import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ErrorBoundary } from './components/ErrorBoundary'
import { HomePage } from './pages/HomePage'
import { GeneratorPage } from './pages/GeneratorPage'
import { VerificationPage } from './pages/VerificationPage'
import { BlogPage } from './pages/BlogPage'
import { BlogPostPage } from './pages/BlogPostPage'
import { ContentPage } from './pages/ContentPage'
import { NotFoundPage } from './pages/NotFoundPage'

function App() {
  return (
    <ErrorBoundary>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/generator" element={<GeneratorPage />} />
          <Route path="/verification" element={<VerificationPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/what-is-llm-txt" element={<ContentPage pageSlug="what-is-llm-txt" />} />
          <Route path="/benefits" element={<ContentPage pageSlug="benefits" />} />
          <Route path="/risks-without-llm-txt" element={<ContentPage pageSlug="risks-without-llm-txt" />} />
          <Route path="/ai-seo-best-practices" element={<ContentPage pageSlug="ai-seo-best-practices" />} />
          <Route path="/implementation-guide" element={<ContentPage pageSlug="implementation-guide" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </ErrorBoundary>
  )
}

export default App
